export default "__VITE_PUBLIC_ASSET__486a6e0e__"